// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__t2F-Q","content":"styles_content__1vbeH","selectAll":"styles_selectAll__4XdDK"};